import React from 'react';
import {
  Box, Icon, IconName, Text,
} from '@usealloy/component-library';

export default function Footer() {
  return (
    <Box
      style={{ height: '100%', padding: '0px var(--cl-space-6)' }}
      gap={2}
      justifyContent="flex-start"
    >
      <Icon icon={IconName.Info} />
      <Text lineHeight={4} as="span">
        <b>
          This view is read only. Please use the local settings tab to make changes
          to configuration options for this service.
        </b>
      </Text>
    </Box>

  );
}
